import {
  deviceRegistrationRequestSchema,
  pushDeviceSchema,
  type DeviceRegistrationRequest,
  type PushDevice,
} from '@/types/api/calling'

import { apiClient } from './client'

/** Registers (or refreshes) this install for push: the Android app and browsers both use it. */
export async function registerDevice(data: DeviceRegistrationRequest): Promise<PushDevice> {
  const response = await apiClient.post('/devices', deviceRegistrationRequestSchema.parse(data))
  return pushDeviceSchema.parse(response.data)
}

/** Stops pushes to this install for the signed-in person in every workspace (sign-out, notifications off). */
export async function removeInstallation(installationId: string): Promise<void> {
  await apiClient.delete(`/devices/installations/${encodeURIComponent(installationId)}`)
}

export async function removeDevice(deviceId: string): Promise<void> {
  await apiClient.delete(`/devices/${deviceId}`)
}
